import type { FC } from "react";
import { memo } from "react";
import type { Country } from "react-phone-number-input/max";

import { InternationalTelephone } from "@ui/components/Telephone/InternationalTelephone";
import { RegularTelephone } from "@ui/components/Telephone/RegularTelephone";

import { useConfig } from "@jti/app-context/useConfig";

export type TelephoneProps = {
  id?: string;
  showLabel?: boolean;
  fieldName?(name: string): string;
  isRequired?: boolean;
  isWithoutDropdown?: boolean;
  isDisabled?: boolean;
  isInfoMessageVisible?: boolean;
  placeholder?: string;
  disclaimer?: string;
  isLocked?: boolean;
  label?: string;
  mode?: "standard" | "editable";
  editButtonLabel?: string;
  onEditClick?: () => void;
  isPhoneFieldFullWidth?: boolean;
  defaultCountry?: Country;
  forceInternationalPhoneNumber?: boolean;
  autoComplete?: string;
};

export const Telephone: FC<TelephoneProps> = memo(
  ({
    id,
    showLabel,
    label,
    fieldName = (name: string) => name,
    isRequired,
    isWithoutDropdown,
    isDisabled,
    isInfoMessageVisible,
    placeholder,
    disclaimer,
    isLocked,
    mode,
    editButtonLabel,
    onEditClick,
    isPhoneFieldFullWidth,
    defaultCountry,
    forceInternationalPhoneNumber = false,
    autoComplete,
  }: TelephoneProps) => {
    const config = useConfig();

    const commontProps = {
      fieldName,
      showLabel,
      isDisabled,
      isRequired,
      autoComplete,
    };

    return (
      <>
        {config.isInternationalPhoneEnabled || forceInternationalPhoneNumber ? (
          <InternationalTelephone
            {...commontProps}
            id={id}
            placeholder={placeholder}
            disclaimer={disclaimer}
            isLocked={isLocked}
            mode={mode}
            label={label}
            editButtonLabel={editButtonLabel}
            onEditClick={onEditClick}
            defaultCountry={defaultCountry}
          />
        ) : (
          <RegularTelephone
            {...commontProps}
            isWithoutDropdown={isWithoutDropdown}
            isInfoMessageVisible={isInfoMessageVisible}
            isPhoneFieldFullWidth={isPhoneFieldFullWidth}
            mode={mode}
            editButtonLabel={editButtonLabel}
            onEditClick={onEditClick}
          />
        )}
      </>
    );
  }
);
